const Loading = (props) => {
  return (
    <div
      id="full-page-loader"
      className={`loader-block d-none ${props.show ? "d-block" : "d-none"}`}
    >
      <div className="loader_img">
        <img src="/assets/images/loader.gif" width="60" alt="..." />
      </div>
    </div>
  );
};

export default Loading;
